"use client"

import { useState } from "react"
import { Phone, Mail, MapPin, Clock } from "lucide-react"

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    agreeToTerms: false,
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Form submitted:", formData)
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  return (
    <div className="w-full">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4">Get In Touch</h2>
        <p className="text-xl text-gray-600">Ready to join the game? We'd love to hear from you!</p>
      </div>

      <div className="grid md:grid-cols-2 gap-12">
        <div className="reveal">
          <h3 className="text-2xl font-bold text-black mb-8">Contact Information</h3>
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#E67E22] rounded-full flex items-center justify-center">
                <Phone className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="font-medium text-black">Phone</p>
                <p className="text-gray-600">+31 6 1234 5678</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#E67E22] rounded-full flex items-center justify-center">
                <Mail className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="font-medium text-black">Email</p>
                <p className="text-gray-600">info@gronsdodgeball.nl</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#E67E22] rounded-full flex items-center justify-center">
                <MapPin className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="font-medium text-black">Location</p>
                <p className="text-gray-600">Sports Center Groningen</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-[#E67E22] rounded-full flex items-center justify-center">
                <Clock className="h-6 w-6 text-white" />
              </div>
              <div>
                <p className="font-medium text-black">Hours</p>
                <p className="text-gray-600">
                  Mon-Fri: 6PM-10PM
                  <br />
                  Sat: 2PM-6PM
                </p>
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-3xl p-8 shadow-lg reveal">
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-black mb-2">Your Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-2xl border border-gray-200 focus:border-[#E67E22] focus:outline-none transition-colors"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-black mb-2">Your Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 rounded-2xl border border-gray-200 focus:border-[#E67E22] focus:outline-none transition-colors"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-black mb-2">Your Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows={4}
                className="w-full px-4 py-3 rounded-2xl border border-gray-200 focus:border-[#E67E22] focus:outline-none resize-none transition-colors"
                required
              />
            </div>
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleChange}
                className="mt-1"
                required
              />
              <span className="text-sm text-gray-600">I agree to the terms and conditions and privacy policy</span>
            </div>
            <button
              type="submit"
              className="w-full bg-[#E67E22] text-white py-3 rounded-full hover:bg-[#D35400] transition-colors font-medium"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
